<template>
  <section
    :style="styling"
    class="md-layout-item md-size-40 md-small-size-100 mx-auto"
  >
    <video
      v-show="showVideo"
      ref="player"
      class="camera"
      autoplay
      playsinline
    />
    <canvas v-show="!showVideo" class="preview" ref="canvas" />
    <md-button
      class="md-layout-item md-success"
      @click.prevent="capture"
      v-if="showVideo"
    >
      {{ captureBtnContent }}
    </md-button>
    <div class="controls" v-else>
      <md-button class="md-layout-item md-info" @click.prevent="done">
        {{ changeBtnContent }}
      </md-button>
    </div>
  </section>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "PhotoCapture",
  props: {
    hideBtns: {
      type: Boolean,
      isRequired: false,
      default: false
    },
    styling: {
      type: Object,
      isRequired: false
    },
    value: {
      default: null
    },
    hideButtons: {
      type: Boolean,
      default: false
    },
    buttonsClasses: {
      type: String,
      default: ""
    },
    captureBtnContent: {
      default: "Tomar Foto"
    },
    cancelBtnContent: {
      default: "Cancelar"
    },
    changeBtnContent: {
      default: "Cambiar"
    }
  },
  data() {
    return {
      showVideo: true,
      picture: null
    };
  },
  mounted() {
    this.videoPlayer = this.$refs.player;
    this.canvasElement = this.$refs.canvas;
    this.streamUserMediaVideo();
  },
  methods: {
    streamUserMediaVideo() {
      if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        return;
      }
      navigator.mediaDevices
        .getUserMedia({ video: true })
        .then(stream => (this.videoPlayer.srcObject = stream))
        .catch(() => {
          Swal.fire({
            title: "Error",
            text: "No pudimos detectar tu camara",
            confirmButtonClass: "md-button md-success",
            buttonsStyling: false
          });
        });
    },
    capture() {
      this.showVideo = false;
      this.canvasElement.width = this.videoPlayer.videoWidth;
      this.canvasElement.height = this.videoPlayer.videoHeight;

      var context = this.canvasElement.getContext("2d");
      context.translate(this.canvasElement.width, 0);
      context.scale(-1, 1);

      context.drawImage(this.$refs.player, 0, 0);

      this.stopVideoStream();
      this.picture = this.$refs.canvas.toDataURL();

      this.$emit("input", this.$refs.canvas);
    },
    done() {
      this.$emit("input", null);
      this.showVideo = true;
      this.streamUserMediaVideo();
    },
    cancel() {
      this.showVideo = true;
      this.streamUserMediaVideo();
    },
    stopVideoStream() {
      if (!(this.$refs.player && this.$refs.player.srcObject)) return;
      this.$refs.player.srcObject.getVideoTracks().forEach(track => {
        track.stop();
      });
    }
  }
};
</script>
